import React from 'react';
import moment from 'moment';
import { DatePicker } from '../../../ClickableField/ClickableField';

class LatestMeetingDateControl extends React.PureComponent {
  render() {
    const { latestMeetingDate, onChange, onClose, className } = this.props;

    return (
      <DatePicker
        className={`${className ? className : ''}`}
        onClose={onClose}
        name="latestMeetingDate"
        format="DD-MMM-YYYY"
        maxDate={moment().add(7, 'days')}
        value={latestMeetingDate ? moment(latestMeetingDate) : null}
        onChange={onChange}
        slotProps={{
          field: { clearable: true }
        }}
      />
    );
  }
}

export default LatestMeetingDateControl;
